import React from 'react';
import { Container } from './styles';
import Search from '~/components/Search';

const RelatorioAuditoriaUsuario: React.FC = () => {
  function defaultOnlyReport() {
    return false;
  }
  return (
    <Container>
      <Search
        codTela={291}
        onlyReport
        newData={defaultOnlyReport}
        onRowClick={defaultOnlyReport}
      />
    </Container>
  );
};

export default RelatorioAuditoriaUsuario;
